import { render, staticRenderFns } from "./IconSvgRemoveSchedule.vue?vue&type=template&id=1686c5b4&scoped=true&"
import script from "./IconSvgRemoveSchedule.vue?vue&type=script&lang=js&"
export * from "./IconSvgRemoveSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686c5b4",
  null
  
)

export default component.exports